import { Button, MenuButton } from "capitalrx-components-2.0/lib/general";
import { SubmitButton, SubmitButtonProps } from "capitalrx-components-2.0/lib/forms";
import { CSSProperties, ComponentProps, FC, PropsWithChildren } from "react";

import "./ThemedButton.scss";

type ThemedButtonProps = ComponentProps<typeof Button> & { $iconcolor?: string };

const getInlineVariableStyle = (buttonColor: string, iconColor: string, style?: CSSProperties): CSSProperties => ({
  ...(style || {}),
  ["--premium-themed-button-color" as string]: buttonColor,
  ["--premium-themed-button-icon-color" as string]: iconColor,
});

export const ThemedButton: FC<PropsWithChildren<ThemedButtonProps>> = (props) => {
  const { $iconcolor, className: incomingClassName, style: incomingStyle, ...buttonProps } = props;
  const iconColor = $iconcolor || "#61646c";
  const className = ["premium-themed-button", incomingClassName].filter(Boolean).join(" ");

  return <Button {...buttonProps} className={className} style={getInlineVariableStyle("#61646c", iconColor, incomingStyle)} />;
};

const _ThemedSubmitButton: FC<PropsWithChildren & SubmitButtonProps> = (props) => {
  const className = ["premium-themed-submit-wrapper", props.className].filter(Boolean).join(" ");

  return (
    <div className={className} style={getInlineVariableStyle("#61646c", "#61646c", props.style)}>
      <SubmitButton {...props}>{props.children}</SubmitButton>
    </div>
  );
};

export const ThemedSubmitButton = _ThemedSubmitButton;

export const ThemedMenuButton: FC<ComponentProps<typeof MenuButton>> = (props) => {
  const className = ["premium-themed-menu-button", props.className].filter(Boolean).join(" ");

  return <MenuButton {...props} className={className} style={getInlineVariableStyle("#61646c", "#61646c", props.style)} />;
};
